export default __webpack_public_path__ + "static/media/operatory.7d515be2.svg";